if (!customElements.get("blobbed-image")) {
  customElements.define(
    "blobbed-image",
    class BlobbedImageRow extends HTMLElement {
      featuredProductImage;

      constructor() {
        super();

        document.addEventListener("DOMContentLoaded", () => this.init());

        if (Shopify.designMode) {
          document.addEventListener("shopify:block:select", (event) => {
            const block = event.target.closest(".product-highlight--wrapper");
            if (block) {
              this.init();
            }
          });

          document.addEventListener("shopify:block:deselect", (event) => {
            const block = event.target.closest(".product-highlight--wrapper");
            if (block) {
              this.init();
            }
          });

          document.addEventListener("shopify:section:select", (event) => {
            const section = event.target.closest(".product-highlight--wrapper");
            if (section) {
              this.init();
            }
          });

          document.addEventListener("shopify:section:deselect", (event) => {
            const section = event.target.closest(".product-highlight--wrapper");
            if (section) {
              this.init();
            }
          });
        }
      }

      init() {
        try {
          // TODO: Extract the featured product image into a snippet
          this.featuredProductImage = this.querySelector(
            ".product-highlight__image-wrapper .featured-product-image",
          );

          if (!this.featuredProductImage) return;

          const { width, height, shadowColor } =
            this.featuredProductImage.dataset;

          if (width && height) {
            const blobMaskURL = createBlobElement(width, height);
            const blobShadowURL = createBlobElement(width, height, shadowColor);

            this.style.setProperty(
              "--featured-image-mask",
              `url(${blobMaskURL})`,
            );
            this.style.setProperty(
              "--featured-image-shadow",
              `url(${blobShadowURL})`,
            );
          }

          this.featuredProductImage.classList.add("visible");

          if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this.buildGSAP();
          }
        } catch (error) {
          console.log("failed to build blob image");
        }
      }

      buildGSAP() {
        const container = this.featuredProductImage.closest(
          ".product-highlight--wrapper",
        );
        const { offsetXEnd, offsetYEnd, scaleEnd, scaleStart } =
          this.featuredProductImage.dataset;

        gsap
          .timeline({
            scrollTrigger: {
              trigger: container,
              start: "top 90%",
              end: "bottom top",
              scrub: 1.5,
              markers: false,
            },
          })
          .to(this, {
            "--shadow-y-offset": `${offsetYEnd}px`,
            "--shadow-x-offset": `${offsetXEnd}px`,
          });
      }
    },
  );
}
